import { render, staticRenderFns } from "./brief.vue?vue&type=template&id=393a955a&"
import script from "./brief.vue?vue&type=script&lang=js&"
export * from "./brief.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports